import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import global from '../src/styles/global';
import { Global } from '@emotion/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import App2, { router } from './App2';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <Global styles={global} />
    {/*<RouterProvider router={router} />*/}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
